import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { StatChartBase, StatChartBaseProps } from './StatChartBase';

export type ResponsiveStatChartBaseProps = ResponsiveComponentProps<StatChartBaseProps>;

export function ResponsiveStatChartBase({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveStatChartBaseProps) {
  return (
    <ResponsiveWrapper width={overrideWidth} height={overrideHeight}>
      {({ width, height }) => {
        return <StatChartBase width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
